import React from 'react';
export function PrivacyContent() {
  return <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-123">
      <p className="text-sm text-[#8b6f6f]" data-id="element-124">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section data-id="element-125">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-126">
          1. Información que Recopilamos
        </h2>
        <p data-id="element-127">
          Recopilamos información que usted nos proporciona directamente cuando
          realiza una compra o se comunica con nosotros.
        </p>
      </section>

      <section data-id="element-128">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-129">
          2. Uso de la Información
        </h2>
        <p data-id="element-130">
          Utilizamos la información para procesar pedidos, proporcionar soporte
          y mejorar nuestros servicios.
        </p>
      </section>

      <section data-id="element-131">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-132">
          3. Protección de Datos
        </h2>
        <p data-id="element-133">
          Implementamos medidas de seguridad para proteger su información
          personal.
        </p>
      </section>
    </div>;
}